export default __webpack_public_path__ + "images/baby_figzy88-60bd282bc5b8bdad0da60cf69d9afbb3.jpg";